module.exports = __webpack_public_path__ + "static/good.428de98b.png";